// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Coordinations_search__jc7fq {
  margin-bottom: 24px;
}
@media (min-width: 640px) {
  .Coordinations_search__jc7fq {
    margin-bottom: 31px;
  }
}

.Coordinations_coordination-container__lFR0x {
  margin-bottom: 32px;
}
.Coordinations_coordination-container__lFR0x ~ .Coordinations_coordination-container__lFR0x {
  margin-bottom: 0;
}
.Coordinations_coordination-container__lFR0x .Coordinations_title__YNiv- {
  margin-bottom: 12px;
  font-weight: 600;
}

.Coordinations_list-container__yLx8g {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Coordinations_skeleton__tmAUo,
.Coordinations_item__BFXcw {
  margin-bottom: 12px;
}
.Coordinations_skeleton__tmAUo:last-child,
.Coordinations_item__BFXcw:last-child {
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .Coordinations_skeleton__tmAUo,
  .Coordinations_item__BFXcw {
    margin-bottom: 0;
  }
}

.Coordinations_skeleton__tmAUo {
  width: 100%;
  height: 164px;
  border-radius: 12px;
}
.Coordinations_skeleton--sm__cMa1C {
  height: 34px;
  margin-bottom: 2px;
}

.Coordinations_nothing__Gi7vR {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 114%;
  margin: auto;
  width: 100%;
  position: absolute;
  top: 50%;
}
@media (min-width: 1200px) {
  .Coordinations_nothing__Gi7vR {
    margin: 20px auto;
    position: initial;
  }
}

.Coordinations_filters-container__xEWpk {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.Coordinations_skeleton-container__Yxepx {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Coordinations_skeleton-container__Yxepx .skeletonBlock {
  height: 170px;
  border-radius: 12px;
}
.Coordinations_skeleton-container__Yxepx.Coordinations_margined__ByxTC {
  margin-top: 12px;
}

.Coordinations_header-container__9lJik {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.Coordinations_header-container__9lJik .title-back {
  margin-bottom: 0;
}
.Coordinations_header-container__9lJik .Coordinations_open-filters__LV5Oe {
  width: 52px;
  height: 52px;
  margin-left: auto;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1607843137);
  border-radius: 65px;
  padding: 8px;
  background: none;
}
.Coordinations_header-container__9lJik .Coordinations_open-filters__LV5Oe .btn__icon {
  position: initial;
  transform: none;
  width: 20px;
  height: 20px;
}
.Coordinations_header-container__9lJik .Coordinations_open-filters__LV5Oe .btn__icon svg {
  width: 100%;
  height: 100%;
}
@media (max-width: 640px) {
  .Coordinations_header-container__9lJik .Coordinations_open-filters__LV5Oe .btn__icon {
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 640px) {
  .Coordinations_header-container__9lJik .Coordinations_open-filters__LV5Oe {
    width: 32px;
    height: 32px;
  }
}
.Coordinations_header-container__9lJik .Coordinations_open-filters__LV5Oe.Coordinations_opened__o1w8d {
  background: #EEEEEE;
}`, "",{"version":3,"sources":["webpack://./src/components/Coordinations/Coordinations.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EAHF;IAII,mBAAA;EAEF;AACF;;AAGE;EACE,mBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,mBAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA;;EAEE,mBAAA;AAHF;AAKE;;EACE,gBAAA;AAFJ;AAKE;EARF;;IASI,gBAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AADF;AAGE;EACE,YAAA;EACA,kBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;AAFF;AAIE;EAVF;IAWI,iBAAA;IACA,iBAAA;EADF;AACF;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;AAII;EACE,aAAA;EACA,mBAAA;AAFN;AAME;EACE,gBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AALF;AAQI;EACE,gBAAA;AANN;AAUE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uDAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AARJ;AAWM;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AATR;AAWQ;EACE,WAAA;EACA,YAAA;AATV;AAYQ;EAXF;IAYI,WAAA;IACA,YAAA;EATR;AACF;AAaI;EA5BF;IA6BI,WAAA;IACA,YAAA;EAVJ;AACF;AAYI;EACE,mBAAA;AAVN","sourcesContent":[".search {\n  margin-bottom: 24px;\n\n  @media (min-width: 640px) {\n    margin-bottom: 31px;\n  }\n}\n\n.coordination-container {\n\n  & {\n    margin-bottom: 32px;\n  }\n  \n  & ~ & {\n    margin-bottom: 0;\n  }\n\n  .title {\n    margin-bottom: 12px;\n    font-weight: 600;\n  }\n}\n\n.list-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.skeleton,\n.item {\n  margin-bottom: 12px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: 768px) {\n    margin-bottom: 0;\n  }\n}\n\n.skeleton {\n  width: 100%;\n  height: 164px;\n  border-radius: 12px;\n\n  &--sm {\n    height: 34px;\n    margin-bottom: 2px;\n  }\n}\n\n.nothing {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 114%;\n  margin: auto;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n\n  @media (min-width: 1200px) {\n    margin: 20px auto;\n    position: initial;\n  }\n}\n\n.filters-container {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.skeleton-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  :global {\n    .skeletonBlock {\n      height: 170px;\n      border-radius: 12px;\n    }\n  }\n\n  &.margined {\n    margin-top: 12px;\n  }\n}\n\n.header-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n\n  :global {\n    .title-back {\n      margin-bottom: 0;\n    }\n  }\n\n  .open-filters {\n    width: 52px;\n    height: 52px;\n    margin-left: auto;\n    box-shadow: 0px 4px 4px 0px #00000029;\n    border-radius: 65px;\n    padding: 8px;\n    background: none;\n\n    :global {\n      .btn__icon {\n        position: initial;\n        transform: none;\n        width: 20px;\n        height: 20px;\n\n        svg {\n          width: 100%;\n          height: 100%;\n        }\n\n        @media (max-width: 640px) {\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n\n    @media (max-width: 640px) {\n      width: 32px;\n      height: 32px;\n    }\n\n    &.opened {\n      background: #EEEEEE;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `Coordinations_search__jc7fq`,
	"coordination-container": `Coordinations_coordination-container__lFR0x`,
	"title": `Coordinations_title__YNiv-`,
	"list-container": `Coordinations_list-container__yLx8g`,
	"skeleton": `Coordinations_skeleton__tmAUo`,
	"item": `Coordinations_item__BFXcw`,
	"skeleton--sm": `Coordinations_skeleton--sm__cMa1C`,
	"nothing": `Coordinations_nothing__Gi7vR`,
	"filters-container": `Coordinations_filters-container__xEWpk`,
	"skeleton-container": `Coordinations_skeleton-container__Yxepx`,
	"margined": `Coordinations_margined__ByxTC`,
	"header-container": `Coordinations_header-container__9lJik`,
	"open-filters": `Coordinations_open-filters__LV5Oe`,
	"opened": `Coordinations_opened__o1w8d`
};
export default ___CSS_LOADER_EXPORT___;
